import { Component, Input } from '@angular/core';
import { BadgeColor, BadgeSize, BadgeValue } from './badge.types';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent {
  @Input() value!: BadgeValue;
  @Input() size: BadgeSize = 'medium';
  @Input() color: BadgeColor = 'red';

  get displayValue(): string {
    const v = this.value;
    if (typeof v === 'number' && v > 99) {
      return '99+';
    }
    return String(v);
  }

  get isDot(): boolean {
    return this.size === 'small';
  }
}
